import React from 'react';

import { AppContextState } from './AppContext.types';

export const AppContext = React.createContext<AppContextState>({
  config: {
    toggles: {
      ops: {
        enableIFrameInteraction: false,
        enableLogging: false,
        applicationFormImage:
          'https://www.argenta.be/content/dam/cover/PSP_najaar_2021_shoppen_496x894-test.jpg',
        applicationConfirmationImage:
          'https://www.argenta.be/content/dam/cover/PSP_najaar_2021_shoppen_496x894-test.jpg',
        applicationGroupsImageBaseUrl:
          'https://aem.simargenta.be/content/dam/argenta/jobs/groepsfoto',
        jobDetailUrls: {
          nl: 'https://www.argenta.be/nl/werken-bij-argenta/vacatures.html?job=',
          fr: 'https://www.argenta.be/fr/travailler-chez-argenta/offres-d-emploi.html?job=',
        },
      },
      features: {
        HB5540_new_vacancy_details: false,
        HB5671_motivation: false,
        HB6056_updated_sectors_new_api: false,
        HB7020_vacancy_details_dynamic_content: false,
      },
    },
  },
});

export const AppContextConsumer = AppContext.Consumer;
export const AppContextProvider = AppContext.Provider;
